import React, {useEffect, useRef} from "react";
import "./fuelIndicator.css";
import key_kms_img from "../../../../assets/images/keyless-return/kms_indicator.svg";
import key_pencil_img from "../../../../assets/images/keyless-return/pencil.svg";

// Máximo de dígitos aceites no odómetro (9 999 999 kms cobre qualquer viatura da frota).
const MAX_KMS_DIGITS = 7;

// Separador de milhares "." (pt-PT), sem depender do locale do dispositivo.
export function formatKms(kms) {
  if (kms === null || kms === undefined || kms === "") return "";
  return String(kms).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function KmsIndicador(
  {
    kms,
    setKms,
    isEditing,
    onToggleEdit,
    t,
  }
) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, MAX_KMS_DIGITS);
    setKms(digits === "" ? null : Number(digits));
  };

  return (
    <div className={`fuel-card${isEditing ? " is-editing" : ""}`}>
      <img
        src={key_kms_img}
        alt="kms"
        className="card-icon"
      />

      {isEditing ? (
        <input
          ref={inputRef}
          className="kms-value kms-value--editing"
          type="tel"
          inputMode="numeric"
          value={kms === null || kms === undefined ? "" : String(kms)}
          onChange={handleChange}
        />
      ) : (
        <div className="kms-value">
          {kms === null || kms === undefined
            ? "-"
            : `${formatKms(kms)} ${t("keylessReturnKmsUnit")}`}
        </div>
      )}

      <button
        type="button"
        className={`card-edit-button${isEditing ? " is-active" : ""}`}
        onClick={onToggleEdit}
      >
        <img
          src={key_pencil_img}
          alt="pencil"
          className="card-icon"
        />
        {isEditing ? t("keylessReturnEditDone") : t("keylessReturnEdit")}
      </button>
    </div>
  );
}
